import { atom } from "recoil";
import { selector, selectorFamily } from "./recoilSelectors";
import { placesLayerState } from "./geojsonState";
import { Place } from "../types/place";
import { Uid } from "../types/core";
import { MAX_SELECTED_PLACES_COUNT } from "../constants/places";

export const allPlacesState = selector({
    key: "places.all",
    get: ({ get }) => {
        const placesLayer = get(placesLayerState);
        if (!placesLayer) {
            return [] as Place[];
        }
        const obj = placesLayer as unknown as GeoJSON.FeatureCollection<GeoJSON.Geometry>;
        if (!obj.features) {
            return [] as Place[];
        }
        return obj.features
            .filter(feat => !!feat?.geometry && !!feat?.properties)
            .map(feat => {
                const point = feat.geometry as any;
                const place = {
                    ...feat.properties,
                    latitude: point.coordinates[1],
                    longitude: point.coordinates[0],
                }
                return place as Place;
            });
    }
});

export const placeState = selectorFamily<Place | undefined, string>({
    key: 'place',
    get: (uid) => ({ get }) => {
        const places = get(allPlacesState);
        return places.find(p => p.uid === uid);
    }
});

// Selection is transient UI state. Persisting tens of thousands of selected IDs
// makes bulk selection expensive and can restore a stale selection after reload.
export const placesSelectedUidsState = atom({
    key: "places.selected.ids",
    default: [] as Uid[],
});

export const placesSelectedState = selector<Place[]>({
    key: "places.selected",
    get: ({ get }) => {
        const uids = get(placesSelectedUidsState);
        if (uids.length > MAX_SELECTED_PLACES_COUNT) {
            return [];
        }
        return uids
            .map(uid => get(placeState(uid)))
            .filter(place => !!place) as Place[]
    },
});
